import { NavLink, Stack, Tooltip } from '@mantine/core'
import {
  IconDashboard,
  IconUsers,
  IconUserQuestion,
  IconApps,
  IconBuilding,
  IconMovie,
  IconSettings,
} from '@tabler/icons-react'
import { Link, useLocation } from 'react-router'

interface NavItem {
  label: string
  path: string
  icon: React.ReactNode
}

const navItems: NavItem[] = [
  { label: 'Dashboard', path: '/dashboard', icon: <IconDashboard size={20} /> },
  { label: 'Users', path: '/users', icon: <IconUsers size={20} /> },
  { label: 'Pending Users', path: '/pending-users', icon: <IconUserQuestion size={20} /> },
  { label: 'Applications', path: '/applications', icon: <IconApps size={20} /> },
  { label: 'Clients', path: '/clients', icon: <IconBuilding size={20} /> },
  { label: 'Titles', path: '/titles', icon: <IconMovie size={20} /> },
  { label: 'Settings', path: '/settings', icon: <IconSettings size={20} /> },
]

interface SidebarProps {
  collapsed?: boolean
}

export function Sidebar({ collapsed }: SidebarProps) {
  const location = useLocation()

  return (
    <Stack gap={4} p="xs">
      {navItems.map((item) => (
        <Tooltip
          key={item.path}
          label={item.label}
          position="right"
          disabled={!collapsed}
        >
          <NavLink
            component={Link}
            to={item.path}
            label={collapsed ? undefined : item.label}
            leftSection={item.icon}
            active={location.pathname === item.path}
            variant="filled"
            style={collapsed ? { justifyContent: 'center' } : undefined}
          />
        </Tooltip>
      ))}
    </Stack>
  )
}
